import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Tooltip from './Tooltip';
import classes from './LockedMeetingTooltip.module.scss';

/**
 * LockedMeetingTooltip component
 * This component will display a tooltip to the user indicating that the control (button, link, etc.) is disabled
 * because the meeting has been locked by the moderator
 * IMPORTANT: the container for this tooltip should have css position: relative
 */
class LockedMeetingTooltip extends React.PureComponent {
  render() {
    return (
      <div className={classes.tooltipWrapper}>
        <Tooltip
          location={'top'}
          overlapCarat={false}
          label={
            <FormattedMessage
              id="components.inCall.tooltip.cannotAddPart"
              defaultMessage="This meeting has been locked by the moderator"
            />
          }
        />
      </div>
    );
  }
}

export default injectIntl(LockedMeetingTooltip);
